import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";

const { patch } = request;
const { Authorization, Bearer } = AUTHORIZATION;

export type updateClaimCategoryByIdListPayloadTypes = {
	idList: string[];
	claimCategory: string;
};

// eslint-disable-next-line arrow-parens
export const updateClaimCategoryByIdList = async (
	updateClaimCategoryByIdListPayload: updateClaimCategoryByIdListPayloadTypes
) => {
	try {
		const payload = JSON.stringify(updateClaimCategoryByIdListPayload);
		const endpoint = "update-claim-category-by-idlist";
		const token = localStorage.getItem("@jwt");
		const response = await patch(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.patch.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};
